// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ClearChangeRequestOrder: Handler = props => {
    props.dispatch({
        type: "Greif/Pages/OrderChange/ClearChangeRequestOrder",
    });
};

export const chain = [ClearChangeRequestOrder];

const clearChangeRequestOrder = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearChangeRequestOrder");
export default clearChangeRequestOrder;
